import { cn } from "~/design-system/lib/utils";

type SeparatorPropsType = {
  orientation?: "vertical" | "horizontal";
  className?: string;
};

export function Separator({
  orientation = "horizontal",
  className,
}: SeparatorPropsType) {
  return (
    <div
      className={cn(
        "bg-[#F5F5F5]",
        orientation === "vertical" ? "h-full w-[1px]" : "h-[1px] w-full",
        className,
      )}
    ></div>
  );
}
